export const paths = {
  login: '/login',
  forgotPassword: '/forgot-password',
  logout: '/logout',
  dashboard: '/dashboard',

  // Super Admin portal
  adminUsers: '/admin-users',
  clientUsers: '/client-users',
  loginLogs: '/login-logs',
  mlLogs: '/ml-logs',
  faqs: '/faqs',
  notifications: '/notifications',
  grievanceArchive: '/archive-grievances',

  // Both portals
  farmers: '/farmers',
  animals: '/animals',
  grievances: '/grievances',

  // Client portal
  administrators: '/administrators',
  agents: '/agents',
} as const;
